import SahraUserGroupsTable from "../../Tables/SahraUserGroups/SahraUserGroupsTable";
import AddEditForm from "./AddEditForm";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import Modal from "../../Components/Modal/Modal";
import { useAppDispatch } from "../../App/hooks";
import { setSahraUserGroupsFormValues } from "../../Features/SahraUserGroups/sahraUserGroupsSlice";
import {
  IAddEditSahraUserGroupFormValues,
  ISahraUserGroupsReport,
} from "../../Interfaces/sahraUserGroupsInterfaces";
import { TabBox } from "../../Components";
import AccountsTable from "../../Tables/SahraUserGroups/AccountsTable";

enum ActiveTab {
  Groups = 0,
  Accounts = 1,
}

const tabs = [
  { index: ActiveTab.Groups, title: "دسته اکانت‌ها" },
  { index: ActiveTab.Accounts, title: "اکانت‌ها" },
];

const SahraUserGroups = () => {
  const dispatch = useAppDispatch();
  const [tableRefreshFlag, setTableRefreshFlag] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(ActiveTab.Groups);

  const closeModal = (saved: boolean) => {
    setIsModalOpen(false);
    if (saved) setTableRefreshFlag(true);
  };

  const openAddModal = () => {
    dispatch(
      setSahraUserGroupsFormValues({
        name: "",
        sahraUserIds: [],
      } as IAddEditSahraUserGroupFormValues),
    );
    setIsModalOpen(true);
  };

  const openEditModal = (row: ISahraUserGroupsReport) => {
    dispatch(
      setSahraUserGroupsFormValues({
        id: row.id,
        name: row.name,
        sahraUserIds: row.memberIds,
      }),
    );
    setIsModalOpen(true);
  };

  return (
    <div className="flex flex-col items-start">
      {isModalOpen ? (
        <Modal
          UI={<AddEditForm onClose={closeModal} />}
          onClose={() => closeModal(false)}
          modalBoxClassName="!min-w-[340px]"
        />
      ) : null}
      <div className="w-full flex items-center justify-between mb-2 mt-5 px-5 gap-3">
        <div className="w-fit">
          <TabBox
            activeTab={activeTab}
            children={tabs}
            onChange={(_, index) => setActiveTab(index)}
          />
        </div>
        {activeTab === ActiveTab.Groups ? (
          <button
            type="button"
            aria-label="اضافه کردن دسته اکانت"
            className="bg-sky-600 rounded-full flex justify-center items-center w-11 h-11 cursor-pointer"
            onClick={openAddModal}
          >
            <AddIcon className="text-white" />
          </button>
        ) : null}
      </div>
      <div className="w-fit self-center">
        {activeTab === ActiveTab.Groups ? (
          <div className="[&_[aria-busy=true]]:min-w-[min(960px,calc(100vw-8rem))]">
            <SahraUserGroupsTable
              tableRefreshFlag={tableRefreshFlag}
              setTableRefreshFlag={setTableRefreshFlag}
              onEdit={openEditModal}
            />
          </div>
        ) : (
          <AccountsTable />
        )}
      </div>
    </div>
  );
};

export default SahraUserGroups;
